import React from "react";
import {Route, Routes} from "react-router-dom";
import {DashboardLayout} from "./DashboardLayout";
import {DashboardPage} from "../pages/dashboard/dashboardPage";
import {MemberPage} from "../pages/members/memberPage";
import {MemberView} from "../pages/members/memberView";
import {MemberNew} from "../pages/members/memberNew";
import {NotificationPage} from "../pages/notifications/notificationPage";
import AuditLogPage from "../pages/auditLog/AuditLogPage";
import {StatementPage} from "../pages/statement/statementPage";
import StatementGeneration from "../pages/statement/StatementGeneration";
import StatementGenerationPreview from "../pages/statement/StatementGenerationPreview";
import {UsersPage} from "../pages/userManagement/usersPage";
import {ProfilePage} from "../pages/profile/ProfilePage";
import ScheduleMonth from "../pages/dashboard/schedule/ScheduleMonth";


export const AuthenticatedRoutes = () => {
    return (
        <DashboardLayout>
            <Routes>
                {/* Define routes for authenticated users */}
                <Route path="/" element={<DashboardPage />} />
                <Route path="/schedule/upload" element={<ScheduleMonth />} />
                <Route path="/members" element={<MemberPage />} />
                <Route path="/members/single" element={<MemberView />} />
                <Route path="/members/new" element={<MemberNew />} />
                <Route path="/notifications" element={<NotificationPage />} />
                <Route path="/audit-logs" element={<AuditLogPage />} />

                {/*===== Statement Generation ======*/}
                <Route path="/statements" element={<StatementPage />} />
                <Route path="/statements/generation" element={<StatementGeneration />} />
                <Route path="/statements/generation/preview" element={<StatementGenerationPreview />} />
                {/*===== End of Statement Generation ======*/}

                <Route path="/user-management" element={<UsersPage />} />
                <Route path="/profile" element={<ProfilePage />} />
            </Routes>
        </DashboardLayout>
    )
}